// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"89":"a96a2dcefdc51e5f","650":"83b705726c303cd8"}[chunkId] + ".js";
};